import Alert, { AlertColor } from '@mui/material/Alert';
import IconButton from '@mui/material/IconButton';
import Snackbar from '@mui/material/Snackbar';
import Tooltip from '@mui/material/Tooltip';
import React, { ReactElement, useState } from 'react';

interface CopyToClipboardProps {
  textToCopy: string;
  icon: ReactElement;
  classNameStyle?: string;
}

type AlertInformation = {
  open: boolean;
  message?: string;
  severity?: AlertColor;
};

const CopyToClipboard: React.FC<CopyToClipboardProps> = ({
  textToCopy,
  icon,
  classNameStyle,
}) => {
  const [alertInformation, setAlertInformation] =
    useState<AlertInformation | null>(null);

  const copyToClipboard = async () => {
    if (!navigator.clipboard) {
      // Clipboard API not available
      return;
    }
    try {
      await navigator.clipboard.writeText(textToCopy);
      setAlertInformation({
        open: true,
        message: 'Copied to clipboard!',
        severity: 'success',
      });
    } catch (err) {
      setAlertInformation({
        open: true,
        message: `Failed to copy! ${err}`,
        severity: 'error',
      });
    }
  };

  const handleClose = (_: React.SyntheticEvent | Event, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }

    setAlertInformation({
      open: false,
    });
  };

  return (
    <div className={classNameStyle}>
      <Tooltip title="Copy to clipboard" arrow>
        <IconButton onClick={copyToClipboard}>{icon}</IconButton>
      </Tooltip>
      {alertInformation !== null && (
        <Snackbar
          open={alertInformation.open}
          autoHideDuration={6000}
          onClose={handleClose}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        >
          <Alert
            onClose={handleClose}
            severity={alertInformation.severity}
            sx={{ width: '100%' }}
          >
            {alertInformation.message}
          </Alert>
        </Snackbar>
      )}
    </div>
  );
};

export default CopyToClipboard;
